import { PageAttributes } from 'scbk-services/types/page/page';
import { create } from 'zustand';

interface PageAttributesStoreState {
    attributes: Record<string, PageAttributes | undefined>;
    set: (id: string, attr: PageAttributes) => void;
    get: (id: string) => PageAttributes | undefined;
}

/**
 * 페이지 속성정보 저장 store
 */
export const usePageAttributesStore = create<PageAttributesStoreState>((set, get) => ({
    attributes: {},
    get: (id: string) => {
        const { attributes } = get();
        return attributes[id];
    },

    set: (id: string, attr?: PageAttributes) => {
        set((state) => {
            return {
                attributes: {
                    ...state.attributes,
                    [id]: {
                        ...state.get(id),
                        ...attr,
                    },
                },
            };
        });
    },
}));

usePageAttributesStore.subscribe((state, _) => {
    sessionStorage.setItem('__PAGE_ATTR__', JSON.stringify(state.attributes));
});
